<script setup lang="ts">
import { toMarkdown } from '@/utils/markdown.ts';

defineProps<{
  text: string;
}>();

function processText(text: string): string {
  text = text.replace(/\\n/g, '\n');
  text = text.replace(/\\\[(.+?)\\\]/gs, (_, expr: string) => `\n$$\n${expr}\n$$\n`);
  text = text.replace(/\\\((.+?)\\\)/gs, (_, expr: string) => `$${expr}$`);
  return text;
}
</script>

<template>
  <div class="prose text-foreground max-w-full" v-html="toMarkdown(processText(text))" />
</template>

<style scoped>

</style>
